import { render, staticRenderFns } from "./StudentNav.vue?vue&type=template&id=a418206a&scoped=true&"
import script from "./StudentNav.vue?vue&type=script&lang=js&"
export * from "./StudentNav.vue?vue&type=script&lang=js&"
import style0 from "./StudentNav.vue?vue&type=style&index=0&id=a418206a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a418206a",
  null
  
)

export default component.exports